import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import "bootstrap-icons/font/bootstrap-icons.css";
import React from 'react';
import ReactDOM from 'react-dom';
import MapSearch from './MapSearch';
import PhotoManagement from './PhotoManagement';
import ReportManagement from './ReportManagement';
import TrafficRegulationManagement from './TrafficRegulationManagement';
import reportWebVitals from './reportWebVitals';

function ShowPage(props) {
  switch(props.pageName){
    case "MapSearch":
    default:
      return <MapSearch />;
    case "PhotoManagement":
      return <PhotoManagement />;
    case "ReportManagement":
      return <ReportManagement />;
    case "TrafficRegulationManagement":
      return <TrafficRegulationManagement />;
  }
}

ReactDOM.render(
  <React.StrictMode>
    <ShowPage pageName={window.SIMPL.pageName} />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
